import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import { MensajeriaUsuarioService } from "../services/mensajeria-usuario.service";

@Injectable()
export class HttpErrorInterceptorService implements HttpInterceptor {
  constructor(
    private translate: TranslateService,
    private mensajeriaUsuario: MensajeriaUsuarioService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next
      .handle(req)
      .pipe(catchError((err, caught) => this.handleHttpError(err)));
  }

  private handleHttpError(error: HttpErrorResponse): Observable<any> {
    let message = "";
    switch (error.status) {
      // Manejo de errores según código de error
      case 400:
        message = "ERROR_HANDLER.BAD_REQUEST";
        break;
      case 401:
        message = "ERROR_HANDLER.UNAUTHENTICATED";
        break;
      case 403:
        message = "ERROR_HANDLER.UNAUTHORIED";
        break;
      case 404:
        message = "ERROR_HANDLER.NOT_FOUND";
        break;
      case 409:
        message = "ERROR_HANDLER.CONFLICT";
        break;
      case 412:
        message = "ERROR_HANDLER.PRECONDITION_FAILED";
        break;
      case 422:
        message = "ERROR_HANDLER.UNPROCESABLE_ENTITY";
        break;
      default:
        message = "ERROR_HANDLER.UNDEFINED";
    }

    if (typeof error.error === "string" && error.status != 0) {
      this.mensajeriaUsuario.notificarError(error.error);
    } else if (
      error.status == 400 &&
      typeof error.error === "object" &&
      this.esExcepcionValidadaPorJackson(error.error)
    ) {
      message = error.error.original.mostSpecificCause.message;
      this.translate
        .get(message)
        .subscribe((mensaje) => this.mensajeriaUsuario.notificarError(mensaje));
    } else {
      this.translate
        .get(message)
        .subscribe((mensaje) => this.mensajeriaUsuario.notificarError(mensaje));
    }

    throw error;
  }

  private readonly FECHA_LIMITADA_NO_VALIDA = "ERROR_HANDLER.FECHA_LIMITADA";

  private esExcepcionValidadaPorJackson(error: any) {
    if (
      error.original.mostSpecificCause.message === this.FECHA_LIMITADA_NO_VALIDA
    ) {
      return true;
    }
    return false;
  }
}
